import React from "react";
import CustomSkeleton from "./Skeleton";

const BackSide = ({ userDetails, aiResponse, formValues}) => {
  {
    console.log(aiResponse, "userDetails");
  }
  return (
    <div className="backside-container page-section">
      <section className="backside-section">
        <div className="left-side-greeting">
          <h4 className="owner-name editable">Hello!</h4>
          <div className="message">
            <p className="editable">{aiResponse &&
              aiResponse.analysis?
              aiResponse.analysis:<CustomSkeleton count={8}/>}</p>
            <p className="editable">{aiResponse &&
            aiResponse.call_to_action ?
            aiResponse.call_to_action:<CustomSkeleton count={4}/>}</p>
          </div>
          {/* <div className="message editable">
          {aiResponse && aiResponse.new_listings && aiResponse.new_listings}
          </div> */}
          {(formValues && formValues.contact && formValues.contact === "show") ? 
          <div className="user_details_container">
           {userDetails && userDetails.avatar && <div className="avatar_wrapper">
            
                <img src={userDetails && userDetails.avatar} />
            
            </div>}
            <div className="user_details_wrapper">
              <h3 className="name editable">
                {userDetails && userDetails.fullName && userDetails.fullName}
              </h3>
              <div className="backside-contact-info">
                <div className="editable">
                  {userDetails && userDetails.email && userDetails.email}
                </div>
                <div className="editable">
                  {userDetails &&
                    userDetails.primaryPhone &&
                    userDetails.primaryPhone}
                </div>
                <div className="editable">
                {userDetails &&
                  userDetails.streetAddress &&
                  userDetails.streetAddress}{" "}
                {userDetails && userDetails.city && userDetails.city}{" "}
                {userDetails && userDetails.state && userDetails.state}{" "}
                {userDetails && userDetails.zipCode && userDetails.zipCode}
              </div>
              </div>
            
            </div>
          </div>
          : null}
        </div>
       

        {/* Postcard Address Section */}
        <div className="address-section">
          <div className="backside-image">
            <div></div>
          </div>
          <div className="address_container">
            <div className=" address editable">
            </div>
            <div className=" address editable"></div>
            <div className=" address editable"></div>
            <div className=" address editable"></div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BackSide;
